class Auth {
    private token = ""

    public setToken(token: string) {
        this.token = token
    }

    public getToken() {
        return this.token
    }

    public clearToken() {
        this.token = ""
    }
}

export const auth = new Auth()
